<template>
  <div>
    <div class="mb-5">
      <b-form-group
        label="Seleccione el tipo de empleado"
        v-slot="{ ariaDescribedby }"
      >
        <b-form-radio-group
          id="radio-group-1"
          v-model="selected"
          :options="options"
          :aria-describedby="ariaDescribedby"
          name="radio-options"
        ></b-form-radio-group>
      </b-form-group>
    </div>
    <div class="w-100">
      <FormEmployee1 v-if="selected === '1'" />
      <FormEmployee2 v-if="selected === '2'" />
    </div>
  </div>
</template>

<script>
import FormEmployee1 from "./FormEmployee1.vue";
import FormEmployee2 from "./FormEmployee2.vue";
export default {
  name: "FormRegister",
  components: {
    FormEmployee1,
    FormEmployee2,
  },
  data() {
    return {
      isEmployeeTercero: false,
      selected: "first",
      options: [
        { text: "Empleado directo", value: "1" },
        { text: "Empleado tercero", value: "2" },
      ],
    };
  },
};
</script>

<style lang="css" scoped></style>
